import AppCache from 'services/AppCache'
import LRUCacheLive from 'services/LRUCacheLive'

const AppCacheLive: AppCache.Shape = { cache: LRUCacheLive }

export default AppCacheLive
